import React from 'react';
import { useSwipeNavigation } from '../../hooks/useSwipeNavigation';

interface WizardStepContainerProps {
  currentStep: number;
  canGoNext: boolean;
  onNext: () => void;
  onPrev: () => void;
  children: React.ReactNode[];
}

const WizardStepContainer: React.FC<WizardStepContainerProps> = ({
  currentStep,
  canGoNext,
  onNext,
  onPrev,
  children,
}) => {
  const swipeHandlers = useSwipeNavigation({
    onSwipeLeft: () => {
      if (canGoNext && currentStep < children.length) onNext();
    },
    onSwipeRight: () => {
      if (currentStep > 1) onPrev();
    },
  });

  return (
    <div
      className="flex-1 overflow-hidden relative"
      {...swipeHandlers}
    >
      <div
        className="flex h-full transition-transform duration-200 ease-out
                    motion-reduce:transition-none"
        style={{ transform: `translateX(-${(currentStep - 1) * 100}%)` }}
      >
        {children.map((child, index) => (
          <div
            key={index}
            className="w-full flex-shrink-0 h-full overflow-y-auto px-4 sm:px-6 pt-4 pb-20"
            role="tabpanel"
            aria-label={`Step ${index + 1}`}
            id={`wizard-step-${index + 1}`}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WizardStepContainer;
